import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';

import { Text, TextType } from 'ui-components/components/text';

import { useImportContext } from '../import-context';
import { messages } from './messages';
import styles from './styles.module.css';

/**
 * @returns {React.ReactNode}
 */
export const InitErrors = () => {
  const { initError } = useImportContext();

  if (!initError) {
    return null;
  }

  return (
    <div className={styles.error} data-testid='init-error'>
      <FontAwesomeIcon className={styles['error-icon']} icon={faExclamationCircle} />
      <Text className={styles['error-message']} textType={TextType.Paragraph} value={messages[initError]} />
    </div>
  );
};
